import { Button } from '@/ui-kit';
import styles from './button-submit-step.module.scss';
import clsx from 'clsx';
import { ArrowBackIcon } from '@/assets/icons';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { eventsApi } from '@/api';
interface Props {
    isLoading?: boolean;
    stepNumber: number;
    href?: string;
    isDisabled?: boolean;
    isGray?: boolean;
    title?: string;
    isIcon?: boolean;
    onSkip?: () => void;
    onClick?: () => void;
}

export const ButtonSubmitStep: React.FC<Props> = ({
    stepNumber = 1,
    isLoading,
    href,
    isDisabled,
    isGray,
    title = 'Дальше',
    isIcon = true,
    onSkip,
    onClick,
}) => {
    const handleSkip = async () => {
        const event = 'skip_step'
        callYaMetrika(event)
        await eventsApi.updateUserEvent(event)
        onSkip?.()
    }

    return (
        <div className={clsx(styles.wrapperButtonStep, isGray && styles.gray)}>
            {
                onSkip &&
                <Button
                    className={styles.skipBtn}
                    type={'button'}
                    onClick={handleSkip}>
                    Пропустить
                </Button>
            }
            <Button
                type="submit"
                variant="stretched"
                typeColor="white"
                textColor={isIcon ? 'white' : 'black'}
                isLoading={isLoading}
                isDisabled={isDisabled}
                isLink={!!href}
                to={href}
                className={
                    clsx(
                        styles.submitBtn,
                        isIcon && styles.submitBtnIconOnly,
                        isIcon && isDisabled && styles.submitBtnIconOnlyDisabled
                    )
                }
                onClick={() => onClick?.()}>
                {
                    isIcon ?
                        <ArrowBackIcon className={styles.submitBtnIcon} width={14} />
                    : title
                }
            </Button>
        </div>
    );
};
